import * as client_hooks from '../../../src/hooks.client.ts';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54'),
	() => import('./nodes/55'),
	() => import('./nodes/56'),
	() => import('./nodes/57'),
	() => import('./nodes/58'),
	() => import('./nodes/59'),
	() => import('./nodes/60'),
	() => import('./nodes/61'),
	() => import('./nodes/62'),
	() => import('./nodes/63'),
	() => import('./nodes/64'),
	() => import('./nodes/65'),
	() => import('./nodes/66'),
	() => import('./nodes/67'),
	() => import('./nodes/68'),
	() => import('./nodes/69'),
	() => import('./nodes/70'),
	() => import('./nodes/71'),
	() => import('./nodes/72'),
	() => import('./nodes/73'),
	() => import('./nodes/74'),
	() => import('./nodes/75'),
	() => import('./nodes/76'),
	() => import('./nodes/77'),
	() => import('./nodes/78'),
	() => import('./nodes/79'),
	() => import('./nodes/80'),
	() => import('./nodes/81'),
	() => import('./nodes/82'),
	() => import('./nodes/83'),
	() => import('./nodes/84'),
	() => import('./nodes/85'),
	() => import('./nodes/86'),
	() => import('./nodes/87'),
	() => import('./nodes/88'),
	() => import('./nodes/89'),
	() => import('./nodes/90'),
	() => import('./nodes/91'),
	() => import('./nodes/92'),
	() => import('./nodes/93'),
	() => import('./nodes/94'),
	() => import('./nodes/95'),
	() => import('./nodes/96'),
	() => import('./nodes/97'),
	() => import('./nodes/98'),
	() => import('./nodes/99'),
	() => import('./nodes/100'),
	() => import('./nodes/101'),
	() => import('./nodes/102'),
	() => import('./nodes/103'),
	() => import('./nodes/104'),
	() => import('./nodes/105'),
	() => import('./nodes/106'),
	() => import('./nodes/107'),
	() => import('./nodes/108'),
	() => import('./nodes/109'),
	() => import('./nodes/110'),
	() => import('./nodes/111'),
	() => import('./nodes/112'),
	() => import('./nodes/113'),
	() => import('./nodes/114'),
	() => import('./nodes/115'),
	() => import('./nodes/116')
];

export const server_loads = [];

export const dictionary = {
		"/": [26],
		"/about-us": [75],
		"/affiliate": [76],
		"/aml-policy": [77],
		"/betfeed": [78],
		"/blog": [79],
		"/bonus-terms": [80],
		"/calendar": [81],
		"/casino": [82],
		"/complaints-and-arbitration": [83],
		"/fairness": [84],
		"/faq": [85],
		"/faq/[section]": [86],
		"/game/[game]": [87,[17]],
		"/in": [88],
		"/in/[actionSlug]": [89],
		"/kyc-policy": [90],
		"/leaderboard": [91],
		"/originals": [92],
		"/originals/[game]": [93,[18]],
		"/payment-policy": [96],
		"/privacy-policy": [97],
		"/promotion-page": [98],
		"/promotion-page/race/[...id]": [100,[22]],
		"/promotion-page/[...id]": [99,[21]],
		"/providers": [101],
		"/p/[provider]": [94,[19]],
		"/p/[provider]/[game]": [95,[19,20]],
		"/races/current": [103],
		"/races/last": [104],
		"/races/next": [105],
		"/races/[raceId]": [102],
		"/referral": [106],
		"/responsible-gaming": [107],
		"/special-bets": [109],
		"/special": [108,[23]],
		"/sports": [110,[24]],
		"/sports/[...slug]": [111,[24,25]],
		"/terms-of-service": [112],
		"/terms-sports": [113],
		"/tournaments": [114],
		"/transparency": [115],
		"/vip": [116],
		"/[provider=provider]": [73,[15]],
		"/[lang=lang]": [29,[3]],
		"/[category=category]": [28,[2]],
		"/[lang=lang]/about-us": [34,[3]],
		"/[lang=lang]/affiliate": [35,[3]],
		"/[lang=lang]/aml-policy": [36,[3]],
		"/[lang=lang]/betfeed": [37,[3]],
		"/[lang=lang]/blog": [38,[3]],
		"/[lang=lang]/bonus-terms": [39,[3]],
		"/[lang=lang]/calendar": [40,[3]],
		"/[lang=lang]/casino": [41,[3]],
		"/[lang=lang]/complaints-and-arbitration": [42,[3]],
		"/[lang=lang]/fairness": [43,[3]],
		"/[lang=lang]/faq": [44,[3]],
		"/[lang=lang]/faq/[section]": [45,[3]],
		"/[lang=lang]/game/[game]": [46,[3,7]],
		"/[lang=lang]/kyc-policy": [47,[3]],
		"/[lang=lang]/leaderboard": [48,[3]],
		"/[lang=lang]/originals": [49,[3]],
		"/[lang=lang]/originals/[game]": [50,[3,8]],
		"/[lang=lang]/payment-policy": [53,[3]],
		"/[lang=lang]/privacy-policy": [54,[3]],
		"/[lang=lang]/promotion-page": [55,[3]],
		"/[lang=lang]/promotion-page/race/[...id]": [57,[3,12]],
		"/[lang=lang]/promotion-page/[...id]": [56,[3,11]],
		"/[lang=lang]/providers": [58,[3]],
		"/[lang=lang]/p/[provider]": [51,[3,9]],
		"/[lang=lang]/p/[provider]/[game]": [52,[3,9,10]],
		"/[lang=lang]/races/current": [60,[3]],
		"/[lang=lang]/races/last": [61,[3]],
		"/[lang=lang]/races/next": [62,[3]],
		"/[lang=lang]/races/[raceId]": [59,[3]],
		"/[lang=lang]/referral": [63,[3]],
		"/[lang=lang]/responsible-gaming": [64,[3]],
		"/[lang=lang]/special-bets": [66,[3]],
		"/[lang=lang]/special": [65,[3,13]],
		"/[lang=lang]/sports": [67,[3]],
		"/[lang=lang]/sports/[...slug]": [68,[3,14]],
		"/[lang=lang]/terms-of-service": [69,[3]],
		"/[lang=lang]/tournaments": [70,[3]],
		"/[lang=lang]/transparency": [71,[3]],
		"/[lang=lang]/vip": [72,[3]],
		"/[lang=lang]/[provider=provider]": [32,[3,5]],
		"/[lang=lang]/[category=category]": [31,[3,4]],
		"/[lang=lang]/[provider=provider]/[game]": [33,[3,5,6]],
		"/[provider=provider]/[game]": [74,[15,16]],
		"/[lang=lang]/[...fallback]": [30,[3]],
		"/[...fallback]": [27]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),

	reroute: (() => {})
};

export { default as root } from '../root.svelte';